'use client';

import { PropsWithChildren } from 'react';

import { DirectionProvider } from '@radix-ui/react-direction';
import { useLocale } from 'next-intl';

import { Theme } from '@/common/enums';
import { BrandingProvider } from '@/components/providers/branding-provider';
import { useConfigValue } from '@/components/providers/config-provider';
import { ThemeProvider } from '@/components/providers/theme-provider';
import { TooltipProvider } from '@/components/ui/tooltip';
import { getTextDirection } from '@/lib/utils/locale';

export function ClientProviders({ children }: PropsWithChildren) {
  const locale = useLocale();
  const direction = getTextDirection(locale);
  const defaultTheme = (useConfigValue('meta.defaultTheme') as Theme) || Theme.Light;

  return (
    <ThemeProvider defaultTheme={defaultTheme}>
      <BrandingProvider>
        <DirectionProvider dir={direction}>
          <TooltipProvider>{children}</TooltipProvider>
        </DirectionProvider>
      </BrandingProvider>
    </ThemeProvider>
  );
}
